module.exports = __webpack_public_path__ + "img/7.874b22f5.jpg";